"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ArrowRight = _interopRequireDefault(require("@paprika/icon/lib/ArrowRight"));

var _ArrowDown = _interopRequireDefault(require("@paprika/icon/lib/ArrowDown"));

var _ArrowUp = _interopRequireDefault(require("@paprika/icon/lib/ArrowUp"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _rawButton = _interopRequireDefault(require("@paprika/raw-button"));

var sc = _interopRequireWildcard(require("./Collapsible.styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** Body content of the collapsible. */
  children: _propTypes["default"].node,

  /** Set's icon alignment left or right. */
  iconAlign: _propTypes["default"].oneOf(["left", "right"]),

  /** Sets RightArrowIcon if true. */
  iconCollapse: _propTypes["default"].node,

  /** Sets DownArrowIcon if true. */
  iconExpand: _propTypes["default"].node,

  /** State of the collapsible. */
  isCollapsed: _propTypes["default"].bool,

  /** If the collapsible is disabled. */
  isDisabled: _propTypes["default"].bool,
  hasOnlyIconToggle: _propTypes["default"].bool,

  /** Sets the label that will display in the collapsible */
  label: _propTypes["default"].node.isRequired,

  /** Callback to be executed when the button is clicked or activated by keyboard. */
  onClick: _propTypes["default"].func,

  /** aria-describedby on the trigger element. */
  triggerAriaDescribedby: _propTypes["default"].string
};
var defaultProps = {
  a11yText: null,
  children: null,
  iconAlign: "left",
  iconCollapse: /*#__PURE__*/_react["default"].createElement(_ArrowRight["default"], null),
  iconExpand: /*#__PURE__*/_react["default"].createElement(_ArrowDown["default"], null),
  isCollapsed: true,
  isDisabled: false,
  hasOnlyIconToggle: false,
  onClick: function onClick() {},
  triggerAriaDescribedby: null
};

var Collapsible = function Collapsible(props) {
  var I18n = (0, _useI18n["default"])();
  var hasWarnedForA11yText = false;
  var collapsedIcon = props.iconAlign === "right" ? [/*#__PURE__*/_react["default"].createElement(_ArrowUp["default"], null), /*#__PURE__*/_react["default"].createElement(_ArrowDown["default"], null)] : [props.iconExpand, props.iconCollapse];

  var checkPropsError = function checkPropsError() {
    if (!props.a11yText && !(I18n && I18n.t) && !hasWarnedForA11yText) {
      hasWarnedForA11yText = true;
      console.error("Error: It is necessary to provide either an a11yText prop or the i18n.t function via the L10n component for Collapsible.");
    }
  };

  var renderDefaultCollapsible = function renderDefaultCollapsible() {
    var a11yText = props.a11yText,
        label = props.label,
        isCollapsed = props.isCollapsed,
        isDisabled = props.isDisabled,
        iconAlign = props.iconAlign,
        triggerAriaDescribedby = props.triggerAriaDescribedby;
    return /*#__PURE__*/_react["default"].createElement(_rawButton["default"], {
      a11yText: a11yText || I18n.t("collapsible.ariaText"),
      "aria-expanded": !isCollapsed,
      className: "collapsible__label",
      "data-pka-anchor": "collapsible.trigger",
      isDisabled: isDisabled,
      onClick: props.onClick,
      "aria-describedby": triggerAriaDescribedby
    }, /*#__PURE__*/_react["default"].createElement("span", {
      "data-pka-anchor": "collapsible.icon",
      className: "collapsible__icon collapsible__icon--".concat(iconAlign),
      "aria-hidden": "true"
    }, collapsedIcon[+isCollapsed]), label);
  };

  var renderCollapsibleByIcon = function renderCollapsibleByIcon() {
    var a11yText = props.a11yText,
        label = props.label,
        isCollapsed = props.isCollapsed,
        isDisabled = props.isDisabled,
        iconAlign = props.iconAlign,
        triggerAriaDescribedby = props.triggerAriaDescribedby;
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-pka-anchor": "collapsible.heading"
    }, /*#__PURE__*/_react["default"].createElement(_rawButton["default"], {
      a11yText: a11yText || I18n.t("collapsible.ariaText"),
      "aria-expanded": !isCollapsed,
      className: "collapsible__label collapsible__label--is-toggle-icon-only collapsible__label--".concat(iconAlign),
      "data-pka-anchor": "collapsible.iconTrigger",
      isDisabled: isDisabled,
      onClick: props.onClick,
      "aria-describedby": triggerAriaDescribedby
    }, /*#__PURE__*/_react["default"].createElement("span", {
      "data-pka-anchor": "collapsible.icon",
      "aria-hidden": "true",
      className: "collapsible__icon"
    }, collapsedIcon[+isCollapsed])), label);
  };

  _react["default"].useEffect(function () {
    checkPropsError();
  });

  var a11yText = props.a11yText,
      children = props.children,
      iconAlign = props.iconAlign,
      iconCollapse = props.iconCollapse,
      iconExpand = props.iconExpand,
      isCollapsed = props.isCollapsed,
      isDisabled = props.isDisabled,
      hasOnlyIconToggle = props.hasOnlyIconToggle,
      onClick = props.onClick,
      label = props.label,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "children", "iconAlign", "iconCollapse", "iconExpand", "isCollapsed", "isDisabled", "hasOnlyIconToggle", "onClick", "label"]);
  var collapsibleProps = {
    isCollapsed: isCollapsed
  };
  var hiddenStyles = {
    display: "none"
  };
  return /*#__PURE__*/_react["default"].createElement(sc.Collapsible, (0, _extends2["default"])({}, collapsibleProps, {
    role: "group"
  }, moreProps), hasOnlyIconToggle ? renderCollapsibleByIcon() : renderDefaultCollapsible(), /*#__PURE__*/_react["default"].createElement("div", {
    className: "collapsible__body",
    style: isCollapsed ? hiddenStyles : null
  }, children));
};

Collapsible.displayName = "Collapsible";
Collapsible.propTypes = propTypes;
Collapsible.defaultProps = defaultProps;
var _default = Collapsible;
exports["default"] = _default;
//# sourceMappingURL=Collapsible.js.map